import { render, staticRenderFns } from "./invoicedetails-component.vue?vue&type=template&id=329d58fc"
import script from "./invoicedetails-component.vue?vue&type=script&lang=ts"
export * from "./invoicedetails-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports